<template>
  <v-dialog
      v-model="dialog"
      transition="dialog-bottom-transition"
    >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
      >
        {{ $t('forms.edit') }}
      </v-btn>
    </template>
    <v-card>
      <ApolloMutation :mutation="UPDATE_USER_PROFILE"
        @done="proceed"
        >
        <template v-slot:default="{ mutate, loading }">
          <v-form @submit="submit(mutate)" onSubmit="return false;">
            <v-container class="text-left">
              <v-row>
                <v-col><h1>{{ $t('userSettings.editUsername') }}</h1></v-col>
              </v-row>
              <v-row v-if="initialized && dialog">
                <v-col style="max-width: 450px">
                  <UsernameTextField
                    @submit="submit(mutate)"
                    v-model="username"
                    :placeholder="$t('admin.users.username')"
                    @valid="valid = $event"
                    :currentUsername="user.userProfile.username"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="auto">
                  <v-btn 
                    :disabled="!canProceed || loading || !valid" 
                    color="primary" 
                    class="px-15"
                    :loading="loading"
                    @click="submit(mutate)">
                    {{ username != user.userProfile.username ? $t('forms.save') : $t('forms.close') }}
                  </v-btn>
                </v-col>
                <v-col cols="auto">
                  <v-btn @click="cancel()">
                    {{ $t('forms.cancel') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </template>
      </ApolloMutation>
    </v-card>
  </v-dialog>
</template>
<script>
import UsernameTextField from "@/components/Reusable/UsernameTextField";
import hasLoggedInUser from "@/mixins/hasLoggedInUser";
import { UPDATE_USER_PROFILE } from "@/graphql/UserQueries";
export default {
  mixins: [hasLoggedInUser],
  name: "EditUsernameDialog",
  components: {
    UsernameTextField,
  },
  data() {
    return {
      dialog: false,
      valid: false,
      username: "",
      initialized: false,
    };
  },
  watch: {
    user: {
      handler: function (newUser) {
        this.username = newUser.userProfile.username;
        this.initialized = true
      },
    }
  },
  computed: {
    UPDATE_USER_PROFILE() {
      return UPDATE_USER_PROFILE;
    },
    canProceed() {
      if (this.valid || this.username == "" || this.username == this.user.userProfile.username) {
        return true;
      }
      return false;
    }
  },
  methods: {
    proceed() {
      this.dialog = false;
    },
    cancel() {
      this.username = this.user.userProfile.username;
      this.dialog = false;
    },
    submit(mutate) {
      if (this.username == this.user.userProfile.username) {
        this.dialog = false;
      }
      else if (this.valid) {
        mutate({
          variables: {
            username: this.username,
            id: this.user.userProfile.id
          }
        });
      }
    }
  },
}
</script>